/**
 * Påminnelser för leads i skedet Pilot: två aktiviteter med påminnelse till
 * leadets ägare, räknade från kampanjofferten (flatbox_offers.leadId):
 *   a) 45 dagar före periodens slut – "Samtal om fortsättning"
 *   b) på slutdagen – "Pilot slutar – fortsätter kunden? Annars stäng åtkomsten"
 *
 * Aktiviteterna har fasta id:n, så synkningen skapar dem första gången och
 * flyttar datumen om offertens datum ändras. En påminnelse som ägaren stängt
 * av förblir avstängd. Inga skedesbyten görs här.
 *
 * Körs när leadet flyttas till Pilot (pipelineData.bytSkede) och när en
 * kopplad offert sparas eller kopplas i Flatbox-konfiguratorn.
 */
import { collection, doc, getDoc, getDocs, query, where, setDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../../firebase/config';
import { kampanjForLead, kampanjText, pilotPaminnelseDatum } from './flatboxLead';

export const PILOT_PAMINNELSER = { samtal: 'pilot-samtal', slut: 'pilot-slut' };

const idag = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};

/** Texterna för påminnelserna (ren funktion). */
export function pilotPaminnelseRader(k) {
  const { samtal, slut } = pilotPaminnelseDatum(k.slut);
  return [
    { id: PILOT_PAMINNELSER.samtal, datum: samtal, text: 'Samtal om fortsättning' },
    { id: PILOT_PAMINNELSER.slut, datum: slut,
      text: k.pilot ? 'Pilot slutar – fortsätter kunden? Annars stäng åtkomsten'
        : 'Prova-på-perioden slutar – fortsätter kunden? Annars stäng åtkomsten' },
  ];
}

/**
 * Skapar eller flyttar påminnelserna för ett lead i Pilot.
 * → { kampanj, rader } eller null om leadet inte är i Pilot eller saknar
 *   kampanjoffert med leveransdatum.
 */
export async function synkaPilotPaminnelser(leadId) {
  if (!leadId) return null;
  const leadSnap = await getDoc(doc(db, 'crmLeads', leadId));
  if (!leadSnap.exists() || leadSnap.data().status !== 'pilot') return null;
  const lead = leadSnap.data();
  const offerter = (await getDocs(query(collection(db, 'flatbox_offers'), where('leadId', '==', leadId)))).docs.map(d => d.data());
  const k = kampanjForLead(offerter);
  if (!k) return null;
  const agare = lead.ownerId || lead.createdBy || '';
  const rader = pilotPaminnelseRader(k);
  for (const r of rader) {
    const ref = doc(db, 'crmLeads', leadId, 'activities', r.id);
    const fore = await getDoc(ref);
    const f = fore.exists() ? fore.data() : null;
    if (f && f.followUpDate === r.datum && f.offerNo === k.offerNo && f.createdBy === agare) continue;
    await setDoc(ref, {
      type: 'note',
      direction: 'out',
      date: f?.date || idag(),
      summary: `${r.text} (${k.offerNo}, ${kampanjText(k)})`,
      followUpDate: r.datum,
      followUpTime: '',
      reminderEnabled: f ? f.reminderEnabled !== false : true,
      reminderLeadTimeDays: 0,
      reminderTime: '07:00',
      reminderDate: r.datum,
      reminderHour: 7,
      createdBy: agare,
      automatisk: 'pilot',
      offerNo: k.offerNo,
      kampanjSlut: k.slut,
      ...(f ? {} : { createdAt: serverTimestamp() }),
      updatedAt: serverTimestamp(),
    }, { merge: true });
  }
  return { kampanj: k, rader };
}
